import SupplierRequestsPage from '@/pages/SupplierRequestsPage.vue';
import SupplierRequestPage from '@/pages/SupplierRequestPage.vue';
import SupplierMatchPage from '@/pages/SupplierMatchPage.vue';
import SupplierChatsPage from '@/pages/SupplierChatsPage.vue';
import SupplierProfilePage from '@/pages/SupplierProfilePage.vue';

/**
 * Кабинет поставщика (ТЗ 6.1, карта маршрутов): список запросов, карточка запроса, проверка
 * сопоставления КП, чаты и карточка поставщика. Пользователь с карточкой поставщика попадает сюда
 * после входа, а переход на другие маршруты приложения ведёт на `/supplier/requests` — это делает
 * глобальный `beforeEach` (ТЗ 6.1, 12.6). Сгенерировано Claude.
 */
export default [
  {
    path: '/supplier/requests',
    name: 'supplier-requests',
    component: SupplierRequestsPage,
    meta: { title: 'Запросы КП' },
  },
  {
    path: '/supplier/requests/:requestId',
    name: 'supplier-request',
    component: SupplierRequestPage,
    meta: { title: 'Запрос КП' },
  },
  {
    path: '/supplier/requests/:requestId/match/:quoteFileId',
    name: 'supplier-match',
    component: SupplierMatchPage,
    meta: { title: 'Проверка сопоставления КП' },
  },
  {
    path: '/supplier/chats',
    name: 'supplier-chats',
    component: SupplierChatsPage,
    meta: { title: 'Чаты' },
  },
  {
    path: '/supplier/chats/:chatId',
    name: 'supplier-chat',
    component: SupplierChatsPage,
    meta: { title: 'Чаты' },
  },
  {
    path: '/supplier/profile',
    name: 'supplier-profile',
    component: SupplierProfilePage,
    meta: { title: 'Карточка поставщика' },
  },
];
